import styles from "../styles.module.scss";
import ButtonOption from "../ButtonOption";
import {useAppData} from "../../context/Contexts";
import {
    formatMoney,
    formatSelectedSeat, getCompareOfferPrice,
    getCurrency, getOfferPrice, getPriceElem,
    isCustom,
    isCustomFront,
    isCustomFrontJump, isCustomJump,
    isCustomThreeRows, parsedSeatUserFriendly
} from "../../helpers/helpers";
import React, {useState, useEffect, useRef} from "react";
import fetchCheck from "../../services/CheckService";
import SuperOffer from "../SuperOffer";

function getNewSeatValue(currentValue: string, isChecked: boolean, currentAppData: {
    step: number | undefined;
    seat: string;
    color: string;
    selectedId: number | undefined;
    year: number;
    make: string;
    model: string;
    check: { compatibility: string; compatibility_custom: string; availability: object } | undefined;
    product: object | undefined;
    originalProduct: object | undefined
} | null) {

    let new_value = currentValue;

    let custom_disabled = false;

    if (currentAppData && currentAppData?.check?.compatibility !== 'N') {
        custom_disabled = true;
    }


    // console.log('cccc', !custom_disabled, currentAppData?.check?.compatibility_custom);
    if (!custom_disabled && currentAppData?.check?.compatibility_custom === 'T') {
        let old_value = currentAppData?.seat;
        if (!old_value) {
            old_value = '';
        }
        if (old_value === 'Bundle') {
            old_value = '';
        }
        const parts = old_value.split(',');
        if (isChecked) {
            parts.push(currentValue);
            new_value = parts.filter(v => v.trim() != '').join(',');
        } else {
            const index = parts.indexOf(currentValue);
            const x = parts.splice(index, 1).filter(v => v.trim() != '');
            new_value = x.join(',');
        }
        const p1 = new_value.split(',');

        if (p1.includes('First Row') && p1.includes('Middle Row') && p1.includes('Back Row')) {
            new_value = 'Bundle';
        }
        if (currentValue === 'Bundle') {
            new_value = 'Bundle';
        }

    }
    /*if (!custom_disabled &&
        (currentAppData?.check?.compatibility_custom === 'Y'
            || currentAppData?.check?.compatibility_custom === 'YF')) {

        if (p1.length === 2 && p1.includes('First Row') && p1.includes('Back Row')) {
            new_value = 'Bundle';
        }
    }*/
    return new_value;
}

export default function Step2(props) {
    const {currentAppData, setCurrentAppData} = useAppData();

    const [options, setOptions] = useState([]);
    const [product, setProduct] = useState({});
    const [comparePrice, setComparePrice] = useState('');
    const [comparePrice1, setComparePrice1] = useState('');
    const [savings, setSavings] = useState<undefined | string>(undefined);
    const [savings1, setSavings1] = useState<undefined | string>(undefined);

    useEffect(() => {
        if (currentAppData === null) {
            return;
        }
        let product1: any;
        if (currentAppData.check && currentAppData.check.compatibility === 'N') {
            product1 = currentAppData.product;
        } else {
            product1 = currentAppData.originalProduct;
        }
        if (product1 && product1.options) {
            setProduct(product1);
            setOptions(product1.options.filter(option => option.name === 'Seats'));
            // console.log('product options', options);
        }

    }, [currentAppData?.check, currentAppData?.product, currentAppData?.originalProduct])


    const handleChange = async (e) => {
        const new_value = e.target.value;

        // console.log('value: ', new_value);
        // console.log('currentAppData: ', currentAppData);

        const new_seat_value = getNewSeatValue(new_value, e.target.checked, currentAppData);
        // console.log('new_seat_value: ', new_seat_value);


        let product = currentAppData.originalProduct;
        if (currentAppData.check && currentAppData.check.compatibility_custom !== 'N') {
            product = currentAppData.product;
        }

        // console.log('product step2', product);
        const filtered = product && product.variants && product.variants.edges.length > 0 ?
            product.variants.edges.filter(el => el.node.title.indexOf(new_value) === 0) : [];
        // console.log('filtered step2', filtered);
        if (filtered.length > 0) {

            if (document && document.querySelector('shopify-payment-terms'))
                document.querySelector('shopify-payment-terms').setAttribute('variant-id', filtered[0].node.id.replace('gid://shopify/ProductVariant/', ''));

            const currency = getCurrency(filtered[0].node.priceV2.currencyCode);
            //setPrice(currency + '' + formatMoney(parseFloat(filtered[0].node.priceV2.amount)));


            if (filtered[0].node.compareAtPrice) {
                setComparePrice(currency + '' + filtered[0].node.compareAtPrice.amount);
                setComparePrice1(filtered[0].node.compareAtPrice.amount);
                setSavings1(filtered[0].node.compareAtPrice.amount - getOfferPrice(filtered[0].node.priceV2.amount));
                setSavings(currency + '' + formatMoney(filtered[0].node.compareAtPrice.amount - getOfferPrice(filtered[0].node.priceV2.amount)));
            } else {
                if (window.scs_show_earlybf_section) {
                    setSavings(currency + '' + formatMoney(20));
                } else {
                    setSavings(undefined);
                }
            }
        } else {
            setSavings(undefined);
        }

        setCurrentAppData(prevState => {
            return {...prevState, seat: new_seat_value}
        })

        const check = await fetchCheck(currentAppData?.year, currentAppData?.make, currentAppData?.model, currentAppData?.trim,
            currentAppData?.color, new_seat_value);
        setCurrentAppData(prevState => {
            return {...prevState, check: check};
        });
    }

    const handleClickChange = (e) => {
        // console.log('handleClickChange 2');
        setCurrentAppData(prevState => {
            return {...prevState, step: 2, seat: '', color: 'Black'}
        })
    }

    const handleAddonChange = (e) => {
        // console.log('handleAddonChange', currentAppData?.addons);
        // console.log('isChecked', e.target.checked);
        let currentValue = e.target.value;
        let new_value = currentAppData?.addons;

        if (!currentAppData?.addons) {
            new_value = currentValue;
        } else {

            const parts = new_value?.split(',');
            const isChecked = e.target.checked;


            if (isChecked) {
                parts?.push(currentValue);
                new_value = parts?.filter(v => v.trim() != '').join(',');
            } else {
                const index = parts?.indexOf(currentValue);
                // console.log('index', index);
                if (index != undefined && index !== -1) {
                    const x = parts.splice(index + 1, 1).filter(v => v.trim() != '');
                    // console.log('new_value x', x);
                    new_value = x.join(',');
                }
            }
        }

        // console.log('handleAddonChange', new_value);

        setCurrentAppData(prevState => {
            return {...prevState, addons: new_value}
        })
    }

    const showCustomDrawer = (e) => {


    }

    // console.log('Step2: ', currentAppData);

    let handleChangeUltimateUpgrade = () => {
        setCurrentAppData(prevState => {
            return {...prevState, ultimate_upgrade: !prevState.ultimate_upgrade}
        })
    };
    return (<>
        {currentAppData?.step && currentAppData?.step > 1 ?
            <>
                <section className={`${styles.section__step} ${currentAppData?.step == 2 ? styles.section_active : ''} 
                ${window.scs_ultimate_upgrade ? styles.has_ultimate : ''} ${window.scs_black_friday_2025 ? styles.has_bf_2025: ''}`}
                         id="step_2">
                    <h2>Step 2/3 - <strong>Seat Options{/* (Add More, Save More)*/}</strong>
                        {/*{(currentAppData?.check?.compatibility === 'N' && currentAppData?.check?.compatibility_custom !== 'N') ? (
                        <a
                            href="#leftModal" className={`${styles.custom_solution}`}
                            onClick={showCustomDrawer}>Custom Seat
                            Cover</a>) : ''}*/}
                    </h2>
                    <div className={`${styles.modal}`} id="leftModal" aria-hidden="true">
                        <div className={`${styles.modalDialog}`}>
                            <div className={`${styles.modalHeader}`}>
                                <h2>Custom Cover Solution</h2>
                                <a href="#" className={`${styles.btnClose}`} aria-hidden="true">×</a>
                            </div>
                            <div className={`${styles.modalBody}`}
                                 dangerouslySetInnerHTML={{__html: `${window.custom_solution_body}`}}>
                            </div>
                            {/*<div className={`${styles.modalFooter}`}>*/}
                            {/*    <a href="#" className={`${styles.btn}`}>Nice!</a>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                    <SuperOffer></SuperOffer>
                    {currentAppData?.step === 2 ? (<>
                        <div
                            className={`${styles.seat_type_selector} ${isCustom(currentAppData) ? styles.custom_seat_type_selector : ''} ${options.length > 0 && Array.from(
                                new Map(options[0].optionValues.map(item => [item.id, item])).values()
                            ).length === 3 && !(currentAppData?.check?.compatibility === 'HF' || currentAppData?.check?.compatibility === 'AF' || currentAppData?.check?.compatibility === 'F') ? styles.grid_3 : ''}`}>
                            {options.length > 0 && Array.from(
                                new Map(options[0].optionValues.map(item => [item.id, item])).values()
                            ).map(el => {
                                let price = '';
                                let comparePrice = '';
                                const priceEl = getPriceElem(product.variants, el.name);
                                // console.log('priceEl:', priceEl);
                                if (priceEl.length > 0) {
                                    const currency = getCurrency(priceEl[0].node.priceV2.currencyCode);
                                    price = currency + formatMoney(getOfferPrice(parseFloat(priceEl[0].node.priceV2.amount)));

                                    if (priceEl[0].node.compareAtPrice) {
                                        comparePrice = currency + formatMoney(getCompareOfferPrice(parseFloat(priceEl[0].node.priceV2.amount), parseFloat(priceEl[0].node.compareAtPrice.amount)));
                                    } else {
                                        if (window.scs_show_earlybf_section) {
                                            comparePrice = currency + formatMoney(parseFloat(priceEl[0].node.priceV2.amount));
                                        }
                                    }
                                }

                                //DONE: check compatibility and show button if there is any color available for this seat (el.name)
                                let enabled = false;
                                if (currentAppData?.check?.compatibility_custom !== 'N') {
                                    enabled = true;
                                } else {
                                    if (currentAppData.check && typeof currentAppData.check.availability !== 'undefined') {
                                        //currentAppData.check.availability[currentAppData.seat].filter(el => )
                                        enabled = currentAppData.check.availability[el.name] && Object.keys(currentAppData.check.availability[el.name])
                                            .filter(v => currentAppData?.check?.availability[el.name][v]).length > 0;
                                    }
                                }

                                //DONE: add option to make button checkboxes (for custom product)

                                //DONE: after selecting vehicle - before moving to step 2 we need to do a check and populate check property of the state
                                if ((currentAppData?.check?.compatibility === 'HF' || currentAppData?.check?.compatibility === 'AF' || currentAppData?.check?.compatibility === 'F') && el.name !== 'Front Seats') {
                                    return (<></>);
                                }

                                if (isCustomFront(currentAppData) && el.name !== 'First Row') {
                                    return (<></>);
                                }

                                let display = (!(isCustom(currentAppData) && el.name.indexOf('Row & ') !== -1));

                                if (currentAppData?.check?.compatibility === 'N' && (currentAppData?.check?.compatibility_custom === 'Y' || isCustomJump(currentAppData))) {
                                    if (el.name.indexOf('Middle Row') !== -1) {
                                        display = false;
                                    }
                                    if (el.name.indexOf('3 Row Bundle') !== -1) {
                                        display = false;
                                    }
                                    if (el.name.indexOf('2 Row Bundle') !== -1) {
                                        display = true;
                                    }
                                }

                                const id = 'btn_' + el.id.replace('gid://shopify/ProductOptionValue/', '');

                                if (window.scs_ultimate_upgrade
                                    && (el.name === 'Universal Back Bench' || el.name === 'Back Bench' || el.name === 'Back Row')
                                ) {
                                    return (<></>);

                                }

                                return (<React.Fragment key={`wrapper-${el.id}`}><ButtonOption key={el.id}
                                                                                               comparePrice={comparePrice}
                                                                                               price={price}
                                                                                               value={el.name} id={id}
                                                                                               name="Seats[]"
                                                                                               diffPrefix={'$'}
                                                                                               diffSuffix={' Savings'}
                                                                                               onChange={handleChange}
                                                                                               display={display}
                                                                                               enabled={enabled}
                                                                                               type={isCustomThreeRows(currentAppData) ? 'checkbox' : 'radio'}
                                                                                               checked={currentAppData.seat && currentAppData.seat.split(',').includes(el.name)}
                                                                                               customCompatibility={currentAppData?.check?.compatibility_custom}
                                />
                                    {(isCustomJump(currentAppData) &&
                                        (
                                            (el.name === 'First Row' && currentAppData.check?.compatibility_custom === 'FJ')
                                            ||
                                            (el.name === '2 Row Bundle' && currentAppData.check?.compatibility_custom === 'YJ')
                                            ||
                                            (el.name === '3 Row Bundle' && currentAppData.check?.compatibility_custom === 'TJ')
                                        )
                                    ) ? (
                                        <ButtonOption key={`${el.id}-addon`}
                                                      price={`$124.99`}
                                                      value="Jump Seat Cover" id={`addon-1`} name="Addons[]"
                                                      onChange={handleAddonChange}
                                                      type='checkbox'
                                                      checked={currentAppData.addons && currentAppData.addons.split(',').includes('Jump Seat Cover')}

                                        />) : ''}
                                </React.Fragment>);
                            })}
                        </div>

                        {savings && !window.scs_black_friday_2025 ? (
                            <div className={`${styles.savings}`}>
                                <svg width="15" height="16" viewBox="0 0 15 16" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <g clipPath="url(#clip0_953_3054)">
                                        <path
                                            d="M13.7499 0.110046H8.55454C8.21086 0.110046 7.7305 0.309154 7.48767 0.551803L0.364771 7.67466C-0.12159 8.16048 -0.12159 8.95698 0.364771 9.4422L5.66835 14.7456C6.15361 15.2314 6.94934 15.2314 7.43534 14.745L14.5582 7.62328C14.8008 7.38067 15 6.89955 15 6.55659V1.3601C15 0.672725 14.4373 0.110046 13.7499 0.110046ZM11.2498 5.11007C10.5594 5.11007 9.99975 4.54981 9.99975 3.86002C9.99975 3.16909 10.5594 2.60997 11.2498 2.60997C11.9402 2.60997 12.5 3.16909 12.5 3.86002C12.5001 4.54981 11.9402 5.11007 11.2498 5.11007Z"
                                            fill="black"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_953_3054">
                                            <rect width="15" height="15" fill="white"
                                                  transform="translate(0 0.109924)"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                                You Saved: <span
                                className={`${styles.savings_price}`}>{savings}</span> ({(savings1 / comparePrice1 * 100).toFixed(0)}%)
                            </div>
                        ) : ''}
                        {window.scs_step_1_bottom_text ? <div className={`${styles.bottom_text}`}
                                                              dangerouslySetInnerHTML={{__html: `${window.scs_step_1_bottom_text}`}}></div> : ''}
                    </>) : (<div className={`${styles.summary}`}>
                        <div
                            className={`${styles.selected_value}`}>{`${parsedSeatUserFriendly(formatSelectedSeat(currentAppData?.seat, product, currentAppData?.check?.compatibility_custom), currentAppData?.check?.compatibility_custom)}`}</div>
                        <button className={`${styles.btn_change}`} onClick={handleClickChange}>Change Seat Type</button>

                    </div>)}


                </section>


                {window.scs_ultimate_upgrade && currentAppData?.seat && currentAppData?.seat != '' ? (
                    <section
                        className={`${styles.section__step} ${styles.section__step_ult} ${currentAppData?.step == 2 ? styles.section_active : ''}`}
                        id="step_2_ultimate">
                        <h2>Ultimate Seat Cover Protection Upgrade</h2>
                        <div className={`${styles.ultimate_wrapper}`}>
                            <img src={'https://cdn.shopify.com/s/files/1/0732/5909/0212/files/ultimate-offer.png?v=1759937838'} style={{maxWidth: '118px'}}/>
                            <ul className={`${styles.ultimate_benefits}`}>
                                <li>2 year Extended Warranty</li>
                                <li>Matching Steering Wheel Cover</li>
                                <li>Seat Cover Care Kit</li>
                            </ul>
                        </div>
                            <React.Fragment key={`wrapper-ultimate-upgrade`}><ButtonOption key={'ultimate-upgrade'}
                                                                                           comparePrice={`$299`}
                                                                                           price={'Only $99'}
                                                                                           showSavingsIcon={true}
                                                                                           value={'Claim This Deal'}
                                                                                           id={'ultimate_upgrade'}
                                                                                           name="ultimate_upgrade"
                                                                                           onChange={handleChangeUltimateUpgrade}
                                                                                           customClass={styles.ultimate_upgrade}
                                                                                           display={true}
                                                                                           enabled={true}
                                                                                           type={'checkbox'}
                                                                                           checked={currentAppData?.ultimate_upgrade == true}

                        />

                        </React.Fragment>

                    </section>
                ) : ''}


            </> : ''}
    </>);
}